// src/plugins/vuetify/theme.js
import { VuetifyThemeVariant } from "vuetify/types/services/theme";
import { appPalette } from "@/theme/palette";

const theme: VuetifyThemeVariant = {
    primary: {
        base: appPalette.primary,
        darken1: appPalette.primaryDark,
    },
    secondary: appPalette.secondary,
    accent: appPalette.secondary,
    info: appPalette.info,
    warning: appPalette.warning,
    success: appPalette.success,
    error: appPalette.error,
};
export default theme;
